// keycloakConfig.js
const keycloakConfig = {
  realm: 'Contaduria',
  url: 'https://auth.cgmisiones.gob.ar',
  clientId: 'plazofijo_prod',
  onLoad: 'login-required',
  verifyToken: true,
  secretKey: '',

  // acr_values: 'normal:1',
};

export default keycloakConfig;